import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getEntity, updateEntity, createEntity, reset } from './bursa-api-end-points.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const BursaAPIEndPointsUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const bursaAPIEndPointsEntity = useAppSelector(state => state.bursaAPIEndPoints.entity);
  const loading = useAppSelector(state => state.bursaAPIEndPoints.loading);
  const updating = useAppSelector(state => state.bursaAPIEndPoints.updating);
  const updateSuccess = useAppSelector(state => state.bursaAPIEndPoints.updateSuccess);
  const handleClose = () => {
    props.history.push('/bursa-api-end-points' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...bursaAPIEndPointsEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };
  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...bursaAPIEndPointsEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="comexApp.bursaAPIEndPoints.home.createOrEditLabel" data-cy="BursaAPIEndPointsCreateUpdateHeading">
            <Translate contentKey="comexApp.bursaAPIEndPoints.home.createOrEditLabel">Create or edit a BursaAPIEndPoints</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="bursa-api-end-points-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('comexApp.bursaAPIEndPoints.order')}
                id="bursa-api-end-points-order"
                name="order"
                data-cy="order"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIEndPoints.orderResult')}
                id="bursa-api-end-points-orderResult"
                name="orderResult"
                data-cy="orderResult"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIEndPoints.bidCert')}
                id="bursa-api-end-points-bidCert"
                name="bidCert"
                data-cy="bidCert"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIEndPoints.otcCert')}
                id="bursa-api-end-points-otcCert"
                name="otcCert"
                data-cy="otcCert"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('comexApp.bursaAPIEndPoints.stbCert')}
                id="bursa-api-end-points-stbCert"
                name="stbCert"
                data-cy="stbCert"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/bursa-api-end-points" replace>
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default BursaAPIEndPointsUpdate;
